const GET_ALL_MERCHANTS = 'v1/restaurants/';
const GET_ALL_PARENTS_BY_IP = 'v1/organization/{{organizationId}}/parents/ip/';
const GET_ALL_PARENTS_BY_LOCATION = 'v1/organization/{{organizationId}}/parents/location/';
const DELETE_ALTERNATE_PAYMENT = 'v1/billing/customer/alternate-payment-id/';

const ENDPOINTS = {
  GET_ALL_PARENTS_BY_LOCATION,
  GET_ALL_PARENTS_BY_IP,
  GET_ALL_MERCHANTS,
  DELETE_ALTERNATE_PAYMENT,
};

export default ENDPOINTS;
